import InlineToken from './InlineToken'
import { tokenizeInline } from './inlineTokens'

/**
 * Unformatted text is returned as a bare string, never wrapped. Every assistant
 * message is mostly plain prose, so wrapping each run in a `<span>` would add a
 * DOM node per run across the whole thread and change what `:first-child` and
 * `white-space` rules apply to.
 */
export function renderTokens(value, keyBase) {
  const tokens = tokenizeInline(value)
  if (tokens.length === 0) return null
  if (tokens.length === 1 && tokens[0].kind === 'plain') return tokens[0].text

  return tokens.map((token, index) =>
    token.kind === 'plain' ? (
      token.text
    ) : (
      <InlineToken key={`${keyBase}-t${index}`} token={token} />
    ),
  )
}
